import { useEffect } from 'react';

/** Sets the browser tab title to "<title> – EvolveX" while mounted.
 *  Pass a falsy title to leave the document title unchanged. */
export default function usePageTitle(title) {
    useEffect(() => {
        if (!title || typeof document === 'undefined') return undefined;
        const previous = document.title;
        document.title = `${title} – EvolveX`;
        return () => { document.title = previous; };
    }, [title]);
}
